const data = {
  title: "Floor 4-1",
  musicTrack: "MUSIC_WORLD4",
  story: "FLOOR FOUR - A BOX FOR YOUR THINGS",
  theme: "GRAY",
  tilesWidth: 11,
  tilesHeight: 7,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 6,
      y: 2
    },
    {
      type: "WALL",
      x: 1,
      y: 4
    },
    {
      type: "WALL",
      x: 3,
      y: 4
    },
    {
      type: "WALL",
      x: 4,
      y: 4
    },
    {
      type: "WALL",
      x: 4,
      y: 1
    },
    {
      type: "WALL",
      x: 4,
      y: 3
    },
    {
      type: "WALL",
      x: 7,
      y: 4
    },
    {
      type: "WALL",
      x: 6,
      y: 4
    },
    {
      type: "WALL",
      x: 5,
      y: 4
    },
    {
      type: "WALL",
      x: 8,
      y: 4
    },
    {
      type: "WALL",
      x: 9,
      y: 4
    },
    {
      type: "WALL",
      x: 10,
      y: 4
    },
    {
      type: "WALL",
      x: 11,
      y: 4
    },
    {
      type: "WALL",
      x: 8,
      y: 5
    },
    {
      type: "WALL",
      x: 8,
      y: 6
    },
    {
      type: "WALL",
      x: 8,
      y: 7
    },
    {
      type: "WALL",
      x: 4,
      y: 5
    },
    {
      type: "WALL",
      x: 4,
      y: 6
    },
    {
      type: "WALL",
      x: 4,
      y: 7
    },
    {
      type: "WALL",
      x: 4,
      y: 2
    },
    {
      type: "TELEPORT",
      x: 2,
      y: 6
    },
    {
      type: "TELEPORT",
      x: 6,
      y: 6
    },
    {
      type: "TELEPORT",
      x: 10,
      y: 6
    },
    {
      type: "TELEPORT",
      x: 10,
      y: 2
    },
    {
      type: "WALL",
      x: 8,
      y: 1
    },
    {
      type: "WALL",
      x: 8,
      y: 3
    },
    {
      type: "ENEMY_SPAWN",
      x: 6,
      y: 5,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 4,
      direction: "DOWN"
    }
  ]
};

export default data;
